import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { MbTextField } from '../../../../components/MbTextFields';

export default function DunsNumber({ errors, register }) {
    return (
        <Box mb={6}>
            <Typography variant="h5" mb={2}>
                DUNS
            </Typography>

            <Grid
                container
                component="form"
                spacing={2}
                direction={'row'}
            >
                <Grid item xs={12} sm={12}>
                    <MbTextField
                        error={errors.dunsNumber?.message}
                        label="Número DUNS"
                        register={register("dunsNumber", {
                            required: false
                        })}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}